;(function() {
  'use strict'

  Controller.$inject = ["$state", "promotionsService"];
  angular
    .module('app.verifyPromotion')
    .controller('VerifyPromotion', Controller)

  /* @ngInject */
  function Controller($state, promotionsService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.ctaUrl = 'https://glo.link/feedandwin'

    function onInit() {
      ctrl.promotion = promotionsService.getInfo()
      promotionsService
        .verifyUserTransaction($state.params.transactionId)
        .then(onSuccess)
        .catch(onError)
    }

    function onSuccess() {
      ctrl.success = true
    }

    function onError() {
      ctrl.success = false
    }
  }
})()
